import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { compose } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';
import { useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { codelistProvider } from 'components';
import OutputTextField from 'components/atoms/GefMui/OutputTextField';
import { codelists } from 'constants/codelists';
import taskDetail from 'features/views/taskDetail';
import { equalOrThreeDashes } from 'utils';

const { additionalInformationFieldsTask17Factory, additionalInformationFieldsTask20Factory } = taskDetail.utils;

export const AdditionalInformationPSGrid = ({ frequencyPaymentsCodelist, systemsCodelist }) => {
	const metadataCommon = useSelector(taskDetail.selectors.getMetaDataCommon);
	const typeId = useSelector(taskDetail.selectors.getTypeId);
	const taskSourceSystemId = useSelector(taskDetail.selectors.getSourceSystemId);

	const renderSeventeen = () => {
		return renderGridCols(additionalInformationFieldsTask17Factory(metadataCommon, frequencyPaymentsCodelist));
	};

	const renderTwenty = () => {
		return renderGridCols(
			additionalInformationFieldsTask20Factory(metadataCommon, taskSourceSystemId, systemsCodelist),
		);
	};

	const renderGridCols = (data) => {
		return data.map((item, i) => (
			<Grid key={i} size={item.size}>
				<OutputTextField
					size="small"
					id={getLabelMessage(item.label)}
					label={getLabelMessage(item.label)}
					multiline={item?.multiline}
					fullWidth
					value={equalOrThreeDashes(isNilOrEmpty(item.value) ? item.value : `${item.value}`.trim())}
					slotProps={{
						inputLabel: {
							shrink: !!equalOrThreeDashes(
								isNilOrEmpty(item.value) ? item.value : `${item.value}`.trim(),
							),
						},
					}}
				/>
			</Grid>
		));
	};

	return (
		<Grid container>
			<Grid size={12}>
				<Grid container spacing={2}>
					{typeId === 17 && renderSeventeen()}
					{typeId === 20 && renderTwenty()}
				</Grid>
			</Grid>
		</Grid>
	);
};

AdditionalInformationPSGrid.propTypes = {
	frequencyPaymentsCodelist: PropTypes.array,
	systemsCodelist: PropTypes.array,
};

export default compose(
	codelistProvider(codelists.payFreq, 'frequencyPaymentsCodelist'),
	codelistProvider(codelists.systems, 'systemsCodelist'),
)(AdditionalInformationPSGrid);
